


















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { AppStore } from '@interface/store/App';

import Logo from '@part/elements/Logo';
import ApplyProgress from '@part/elements/ApplyProgress';
import UserDropdown from '@part/elements/UserDropdown';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            showApplyProgress: false,
        }
    },

    components: {
        Logo,
        ApplyProgress,
        UserDropdown,
    },

    created() {
        this.$root.$on('root::layout::showApplyProgress', (showApplyProgress) => {
            this.showApplyProgress = showApplyProgress;
        });
    },

    computed: {
        applyRoute() {
            return (!this.showApplyProgress && this.isLoggedIn) ? '/apply' : '/login';
        },

        cLogoClass() {
            const classes = ['page-header__logo'];

            if (!this.showApplyProgress)
                classes.push('page-header__logo--center');

            if (this.showApplyProgress)
                classes.push('page-header__logo--left');

            return classes.join(' ');
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class PageHeader extends Vue {};

